import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA, MatDialogModule } from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';

@Component({
    selector: 'sentry-confirm-dialog',
    templateUrl: './confirm-dialog.component.html',
    standalone: true,
    imports: [MatDialogModule, MatButtonModule]
})
export class ConfirmDialogComponent {
  message = '';
  confirmButtonText = 'Confirm';
  cancelButtonText = 'Cancel';

  constructor(
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    @Inject(MAT_DIALOG_DATA) private data: any,
    private dialogRef: MatDialogRef<ConfirmDialogComponent>
  ) {
    if (data) {
      this.message = data.message || this.message;
      if (data.buttonText) {
        this.cancelButtonText = data.buttonText.cancel;
        this.confirmButtonText = data.buttonText.ok;
      }
    }
  }

  onConfirmClick(): void {
    this.dialogRef.close(true);
  }
}
